import { uniqBy } from 'lodash';

export default function RainData(currentMode, currentArea, datas, dataTime) {
  function getValue(rules, value, raintype) {
    for (let i = 0; i < 2; i += 1) {
      // eval is needed
      // eslint-disable-next-line no-eval
      if (eval(value + rules[i].operator + rules[i][raintype])) {
        return rules[i].level;
      }
    }
    return 0;
  }
  const mode = currentMode;
  const area = currentArea;
  const raindatas = datas.data.data;
  const settings = datas.setting;
  let filterAreaData;
  if (mode === 'province' && area.code !== '0') {
    filterAreaData = raindatas.filter((d) => d.geocode.province_code === area.code);
  } else if (mode === 'basin' && area.code !== '0') {
    filterAreaData = raindatas.filter((d) => d.basin.basin_code === parseInt(area.code, 10));
  } else {
    filterAreaData = raindatas;
  }
  const dataFilterArea = filterAreaData.filter((d) => {
    const warningZone = d.geocode.warning_zone;
    const rule = settings.rule[warningZone];
    // console.log(rule);
    // ตรวจสอบว่า rule มีค่าหรือไม่
    if (!rule) {
      // console.warn(`Warning: No rule found for warning zone ${warningZone}`, d);
      return false; // ข้ามข้อมูลนี้ไปเพราะ rule ไม่มี
    }

    const rain24Value = getValue(rule, d.rain_24h, 'rain24h');
    const rain1Value = getValue(rule, d.rain_1h, 'rain1h');

    return Math.max(rain24Value, rain1Value) >= 3;
  }).map((row) => {
    const warningZone = row.geocode.warning_zone;
    const rule = settings.rule[warningZone] || [];

    const rain24level = getValue(rule, row.rain_24h, 'rain24h') || 0;
    const rain1level = getValue(rule, row.rain_1h, 'rain1h') || 0;
    const level = Math.max(rain24level, rain1level);
    const color = settings.level_color[level];
    const color24 = settings.level_color[rain24level];
    const color1 = settings.level_color[rain1level];
    let name = '';
    if (area.code !== '0') {
      name = row.geocode.amphoe_name.th;
    } else if (area.code === '0') {
      name = row.geocode.province_name.th;
    }
    return ({
      rain_24: row.rain_24h,
      rain_1: row.rain_1h,
      level,
      color,
      color24,
      color1,
      name,
      tele_station_name: row.station.tele_station_name.th,
      tele_station_oldcode: row.station.tele_station_oldcode,
      tele_station_lat: row.station.tele_station_lat,
      tele_station_long: row.station.tele_station_long,
      province_code: row.geocode.province_code,
      province_name: row.geocode.province_name.th,
      amphoe_name: row.geocode.amphoe_name.th,
      tumbon_name: row.geocode.tumbon_name.th,
      time: row.rainfall_datetime,
      agency_name: row.agency.agency_name.th,
    });
  });

  // console.log(dataFilterArea);
  const RainFiltered = uniqBy(dataFilterArea, 'name')
    .sort((a, b) => a.province_name.localeCompare(b.province_name, 'th'));
  const RainYellow = uniqBy(RainFiltered.filter((d) => d.level === 3), 'name')
    .sort((a, b) => a.province_name.localeCompare(b.province_name, 'th'));
  const RainRed = uniqBy(RainFiltered.filter((d) => d.level === 4), 'name')
    .sort((a, b) => a.province_name.localeCompare(b.province_name, 'th'));

  const RainCount = RainRed.length;

  const RainList = {
    time: dataTime,
    count: RainCount,
    red: RainRed,
    yellow: RainYellow,
  };

  return ({
    RainList,
    dataFilterArea,
  });
  // setRainList(RainList);
  // setDataRain(dataFilterArea);
}
